import React from "react";

import { BetBuilderPickActionsTypeEnum } from "@data-types/analytics-tracker/QuickPlayInteractionTypeEnum";
import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import { BetBuilderPicksStore } from "@state/quick-play-store/BetBuilderPicksStore";
import { analyticsTracker } from "@utils/analytics";
import classnames from "classnames";
import { observer } from "mobx-react";

export default observer(function BetBuilderPicksQuotaButton(props: {
	BBPick: BetBuilderPick;
	isInPopup?: boolean;
	store: BetBuilderPicksStore;
}) {
	const { BBPick, isInPopup = false } = props;

	const addOrRemovePick = async (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		e.stopPropagation();

		if (props.store.isAddingOrRemovingPick) {
			return;
		}

		analyticsTracker.trackQuickPlayInteraction(
			BetBuilderPickActionsTypeEnum.PickUse
		);

		if (!props.store.checkIsSelectedMultiOfferOnSlip(BBPick)) {
			analyticsTracker.trackUseTicketEvent("bb-picks");
		}
		await props.store.addOrRemoveBetBuilderPickOnSlip(BBPick);

		if (isInPopup) {
			props.store.deactivatePopup();
		}
	};

	const isQuoteActive = props.store.checkIsSelectedMultiOfferOnSlip(BBPick);

	return (
		<button
			onClick={addOrRemovePick}
			className={classnames("card--bbp__quota btn quote--button", {
				"quote quote--button--bbp card--bbp--nowrap__quota": !isInPopup,
				"btn--med btn--block": isInPopup,
				"is-active": isQuoteActive,
				"btn--icon inc": BBPick.indicator > 0,
				"btn--icon desc": BBPick.indicator < 0,
			})}
		>
			<strong className="quote--button__odd u-type--center">
				{props.BBPick.bbMaxCoefficient.toFixed(2)}
			</strong>
		</button>
	);
});
